function updateLinksInContainer(container) {
  const messages = container.querySelectorAll('.bss-lock-element');
  messages.forEach((message) => {
    const linkElement = message.querySelector('.bss-lock-message-element-3607');
    if (linkElement && !linkElement.dataset.bssRedirected) {
      linkElement.href = '/pages/wholesale-registration-form';
      linkElement.classList.add('button', 'button--full-width', 'button--secondary');
      linkElement.style = 'display:flex!important;color: inherit!important;border: none!important'
      linkElement.dataset.bssRedirected = 'true';
    }
  });
}

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) { 
        updateLinksInContainer(node);
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

document.addEventListener('DOMContentLoaded', () => {
  updateLinksInContainer(document);

  setTimeout(() => {
    const checkbox = document.querySelector(
      '#checkbox-group-69515fb0b5189-0'
    );

    if (!checkbox) return;

    function toggleFields() {
      const billingField = [...document.querySelectorAll('.field-header')]
        .find(el => el.textContent.trim() === 'Billing Address');

      if (!billingField) return;

      let next = billingField.nextElementSibling;
      let count = 0;

      while (next && count < 6) {
        if (next.classList.contains('field-text')) {
          next.style.display = checkbox.checked ? 'none' : '';
          count++;
        }
        next = next.nextElementSibling;
      }
    }

    checkbox.addEventListener('change', toggleFields);
    toggleFields();
  }, 2000);
});

const ADDRESS_INPUT_MAP = new Map([
    ["first_name", "first-name"],
    ["last_name", "last-name"],
    ["address1", "address-field"],
    ["address2", "apartment-field"],
    ["city", "city-field"],
    ["zip", "zip-field"],
    ["country_code", "country-field"],
    ["country_name", "country-name"],
    ["company", "company-field"],
    ["province", "state-name"],
    ["province_code", "state-field"],
]);

function watchB2BAddressSelect() {
    const findSelect = setInterval(() => {
        const select = document.querySelector('#b2b-nt-address-select');
        if (!select) return;
      
        const options = Array.from(select.querySelectorAll('option'));
        const hasNew = options.some(opt => opt.value === 'new');
        const otherOptions = options.filter(opt => opt.value !== 'new');
        if (hasNew && otherOptions.length > 0) {
          const { customer } = window.BSS_B2B?.shopData;
          const options = [];
      
          customer?.addresses?.forEach((item) => {
              const address = [item.address1, item.country].filter(Boolean).join(" ");
              const name = [item.first_name, item.last_name].filter(Boolean).join(" ");
              options.push({ id: item.id, label: `${address} (${name})` });
          });
          select.addEventListener('change', (e) => {
             [...ADDRESS_INPUT_MAP.keys()].forEach((key) => {
                  const inputId = ADDRESS_INPUT_MAP.get(key);
                  const input = document.querySelector(`#b2b-nt-address-info #${inputId}`) || document.querySelector(`.b2b-nt-addition-info #${inputId}`);
                  if (input) {
                      input.value = "";
                      input.dispatchEvent(new Event("change", { bubbles: true }));
                  }
              });
              const selectedValue = e.target.value;
              const address = customer?.addresses?.find(addr => addr.id === Number(selectedValue));
              console.log(address)
              if (address) {
                  [...ADDRESS_INPUT_MAP.keys()].forEach((key) => {
                      const inputId = ADDRESS_INPUT_MAP.get(key);
                      const input = document.querySelector(`#b2b-nt-address-info #${inputId}`) || document.querySelector(`.b2b-nt-addition-info #${inputId}`);
                      if (input) {
                          input.value = address[key] || "";
                          input.dispatchEvent(new Event("change", { bubbles: true }));
                      }
                  });
              }
          });
          
          if (select.value === 'new') {
                select.value = otherOptions[0].value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        clearInterval(findSelect);
    }, 100);

    setTimeout(()=> {
      clearInterval(findSelect);
    },3000)
  
}

const findButtonInterval = setInterval(() => {
    const ntBtn = document.querySelector('#bss-b2b-net-term-button');
  if (ntBtn) {
    ntBtn.addEventListener('click', () => {
          watchB2BAddressSelect();
    });
    clearInterval(findButtonInterval);
  }
}, 200);

setTimeout(()=> {
  clearInterval(findButtonInterval);
},3000)
